/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A place for VDK Web CTV UI components and utilities (@accedo/vdkweb-tv-ui) 7.1.2
* 
*******************************************************************************/
/**
 * Prefix is for iterable children in setting navigation ids. This helper function will generate
 * unique prefix and cache in component. As navigation id has to be unique within the application.
 *
 * @param {Object} scope Scope to trigger the function
 * @returns {String} prefix
 */
var updatePrefix = function updatePrefix(scope) {
  var prefix = scope.prefix;
  if (scope.props && scope.props.prefix) {
    prefix = scope.props.prefix;
  }
  if (!prefix) {
    prefix = Date.now().toString(36);
  }
  scope.prefix = prefix;
  return prefix;
};
var updateLayoutMap = function updateLayoutMap(scope, arr, numOfCol) {
  var layoutMap = scope.layoutMap;
  if (scope.props && scope.props.layoutMap) {
    layoutMap = scope.props.layoutMap;
  }
  if (!layoutMap) {
    var prefix = updatePrefix(scope);
    layoutMap = '';
    for (var i = 0, l = arr.length; i < l; i += 1) {
      layoutMap += prefix + i + ((i + 1) % numOfCol ? '  ' : '\n');
    }
  }
  scope.layoutMap = layoutMap;
  return layoutMap;
};
var NOOP = function NOOP() {};
export { updatePrefix, updateLayoutMap, NOOP };